interface Props {
  tagsAsKeyValueArray: { key: string; value: string }[];
}

export function kindMobxToTagsModel(item: Props) {
  return item.tagsAsKeyValueArray.map((i: any, idx: number) => ({ ...i, index: idx, status: "default" }));
}
